import { useState } from "react";

// Landing page components
import { Navigation, FloatingWhatsApp, Footer } from "../components/landing/Layout";
import HeroSection from "../components/landing/HeroSection";
import PublicCounter from "../components/landing/PublicCounter";
import CategoryCards from "../components/landing/CategoryCards";
import DesignTabs from "../components/landing/DesignTabs";
import PrivacySection from "../components/landing/PrivacySection";
import HowItWorks from "../components/landing/HowItWorks";
import TrustedContactsSection from "../components/landing/TrustedContactsSection";
import RealLifeCases from "../components/landing/RealLifeCases";
import PricingCard from "../components/landing/PricingCard";
import FAQSection from "../components/landing/FAQSection";
import CTASection from "../components/landing/CTASection";

const Landing = () => {
  const [showWhatsAppOptions, setShowWhatsAppOptions] = useState(false);
  const [activeTab, setActiveTab] = useState("vehiculos");
  const [openFaq, setOpenFaq] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Floating WhatsApp Button */}
      <FloatingWhatsApp 
        showWhatsAppOptions={showWhatsAppOptions} 
        setShowWhatsAppOptions={setShowWhatsAppOptions} 
      />

      {/* Navigation */}
      <Navigation />

      {/* Hero Section with Image Slider */}
      <HeroSection />
      <PublicCounter />

      {/* Category Cards - ¿Dónde usar AvisoCar? with modals */}
      <CategoryCards 
        selectedCategory={selectedCategory} 
        setSelectedCategory={setSelectedCategory} 
      />

      {/* Design Tabs - Diseños para cada necesidad */}
      <DesignTabs activeTab={activeTab} setActiveTab={setActiveTab} />

      {/* Privacy Section */}
      <PrivacySection />

      {/* How It Works */}
      <HowItWorks />

      {/* Trusted contacts (F6) marketing */}
      <TrustedContactsSection />

      {/* Real Life Cases */}
      <RealLifeCases />

      {/* Pricing */}
      <PricingCard />

      {/* FAQ */}
      <FAQSection openFaq={openFaq} toggleFaq={toggleFaq} />

      {/* Final CTA */}
      <CTASection />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Landing;
